<ng-container *ngIf="event">
  <ng-container *ngIf="event.urlSlug; else tpl">
    <a *ngIf="isExternalUrl()" [href]="this.event.urlSlug" class="link-wrapper">
      <ng-container *ngTemplateOutlet="tpl"></ng-container>
    </a>
    <a *ngIf="!isExternalUrl()" [routerLink]="[this.event.urlSlug]" class="link-wrapper">
      <ng-container *ngTemplateOutlet="tpl"></ng-container>
    </a>
  </ng-container>
  <ng-template #tpl>
    <mb-media *ngIf="event.image" [media]="event.image"></mb-media>
    <header *ngIf="event.state === eventStates.UPCOMING">
      <mb-small-spinner></mb-small-spinner>
      <span *ngIf="distance">
        {{ 'EVENT_CARD_STARTS_IN' | translate : { distance: distance } }}
      </span>
    </header>
    <header *ngIf="event.state === eventStates.RUNNING">
      <mb-live-indicator></mb-live-indicator>
      {{ 'EVENT_CARD_RUNNING' | translate }}
    </header>
    <span
      *ngIf="event.attendanceStatus"
      class="event-card-icon mb-icon mb-icon-event-{{ attendanceIcons[event.attendanceStatus] }}"
    >
    </span>
    <section>
      <span *ngIf="event.titleHash" class="title-hash">{{ event.titleHash }}</span>
      <h2 clas="event-title" [innerHTML]="event.title"></h2>
      <time
        *ngIf="event.startDate && event.endDate"
        class="event-date"
        [attr.start]="event.startDate"
        [attr.end]="event.endDate"
      >
        {{ event.startDate | timePeriod : event.endDate : event.timezoneOffset }}
      </time>
      <div
        *ngIf="
          event.deadline &&
          (event.attendanceStatus === attendance_status.PENDING || event.attendanceStatus === attendance_status.OPEN)
        "
      >
        <em>{{
          'EVENT_RIBBON_CARD_EMBARGO_UNTIL' | translate : { date: event.deadline | localizedDate : 'longDate' }
        }}</em>
      </div>
    </section>
    <footer>
      <div class="location" *ngIf="event.location" [innerHTML]="event.location"></div>
      <div class="pages" *ngIf="index && total">{{ index }} / {{ total }}</div>
    </footer>
  </ng-template>
</ng-container>
